import data from "../../.sourceflow/grade.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const grade_helper = new CollectionHelper(data);
